import Format from "../singleton/format";

export default {

    byFieldId: Format.byFieldId.bind(Format),

    byField: Format.byField.bind(Format),

    document: Format.document.bind(Format)

}